export const UPDATE_DIMENSIONS = "update_dimensions";
